export const AUDIT_LOG_ROOT_PATH = '/auditlog/dashboard';
